import { getWechatJSConfig } from '../../services/api'
import { debug } from './utils'

const WECHAT_JSSDK_CONFIG = {
  debug: false,
  openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app', 'wx-open-subscribe', 'wx-open-audio'],
  jsApiList: [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
  ],
}

export const configWechatJSSDK = (url = document.location.href) =>
  getWechatJSConfig(url).then((response) => {
    console.log(`Config Wechat JSSDK for ${url}...`)
    console.log('API response of ios wechat jssdk signature: ', JSON.stringify(response))
    const jsConfig = {
      ...WECHAT_JSSDK_CONFIG,
      ...response.data,
    }
    debug('Wechat JSSDK config: ', jsConfig)
    /* global wx */
    wx.config(jsConfig)
    wx.ready((e) => {
      document.addEventListener('WeixinOpenTagsError', function (e) {
        console.error('!!!!!!!!!!!!!!!!WeixinOpenTagsError!!!!!!!!!!!!!!!!!!!!!')
        console.error(e.detail.errMsg)
        console.error('!!!!!!!!!!!!!!!!WeixinOpenTagsError!!!!!!!!!!!!!!!!!!!!!')
      })

      document.addEventListener('WeixinOpenTagsReady', function (e) {
        console.error('!!!!!!!!!!!!!!!!WeixinOpenTagsReady!!!!!!!!!!!!!!!!!!!!!')
        console.error(e)
        console.error('!!!!!!!!!!!!!!!!WeixinOpenTagsReady!!!!!!!!!!!!!!!!!!!!!')
      })
      console.log('Wechat JSSDK config is done.')
    })
    wx.error((e) => {
      console.log('Wechat JSSDK config failed: ', e)
    })

    // props.saveWechatJsConfig(response.data);
  })
